// extracted by mini-css-extract-plugin
module.exports = {"text":"dd31006766--text--rFavR"};